import { ApplicantModel } from '@/lib/api/applicant.model'
import { ApplicationListModel } from '@/lib/api/application.model'
import { createContext } from 'react'

type ApplicationState = {
  applicant: ApplicantModel | undefined
  applications: ApplicationListModel[]
  sidebarOpen?: boolean
}

type Action<T, K> = {
  action: T
  payload: K
}

type Actions =
  | Action<'SET_APPLICANT', ApplicantModel>
  | Action<'REMOVE_APPLICANT', ApplicantModel>
  | Action<'SET_APPLICATIONS', ApplicationListModel[]>
  | Action<'SET_SIDEBAR_STATE', boolean>

export const initialState: ApplicationState = {
  applicant: undefined,
  applications: [],
  sidebarOpen: false,
}

export const applicationStateReducer = (state: ApplicationState, input: Actions) => {
  switch (input.action) {
    case 'SET_APPLICANT':
      return {
        ...state,
        applicant: input.payload,
      }
    case 'REMOVE_APPLICANT':
      return {
        ...state,
        applicant: undefined,
      }
    case 'SET_APPLICATIONS':
      return {
        ...state,
        applications: input.payload,
      }
    case 'SET_SIDEBAR_STATE':
      return {
        ...state,
        sidebarOpen: input.payload,
      }
    default:
      return state
  }
}

type ContextProvider = {
  state: ApplicationState
  dispatch: (action: Actions) => void
}

export const ApplicationContext = createContext<ContextProvider | null>(null)
